import { faHourglassEnd } from '@fortawesome/pro-light-svg-icons';
import { faShieldCheck } from '@fortawesome/pro-light-svg-icons/faShieldCheck';
import { faWarning } from '@fortawesome/pro-light-svg-icons/faWarning';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Flex, Image, Row, Space, theme } from 'antd';
import OrderPartsImage from 'pos-client/assets/avayler-order-parts.png';
import OrderPartsImageError from 'pos-client/assets/avayler-order-parts-errors.png';
import {
  successGradientColor,
  warningGradientColor,
} from 'pos-client/theme/DefaultTheme.ts';

interface PosModalBannerProps {
  bannerType?: 'error' | 'success' | 'loading' | undefined;
}

export const PosModalBanner = ({ bannerType }: PosModalBannerProps) => {
  const { token } = theme.useToken();
  const styles = {
    marginBottom: token.margin,
    paddingTop: token.marginXXL,
    background:
      bannerType === 'error' ? warningGradientColor : successGradientColor,
  };

  const mapIcon = () => {
    switch (bannerType) {
      case 'error':
        return (
          <FontAwesomeIcon size="4x" icon={faWarning} color={token.gold9} />
        );
      case 'success':
        return (
          <FontAwesomeIcon
            size="4x"
            icon={faShieldCheck}
            color={token.colorSuccessText}
          />
        );
      case 'loading':
        return (
          <FontAwesomeIcon
            size="4x"
            icon={faHourglassEnd}
            color={token.colorTextBase}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Flex vertical style={styles} justify="center">
      <Row>
        <Col span={8} offset={8}>
          <Space size="large" direction="vertical" align="center">
            <Image
              src={
                bannerType === 'error' ? OrderPartsImageError : OrderPartsImage
              }
              preview={false}
            />
            {mapIcon()}
          </Space>
        </Col>
      </Row>
    </Flex>
  );
};
